import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'

const controller = 'Helper'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  ValidaDigito (valor) {
    const regex = /(\d{3})-(\d{1})/;
    return [regex.test(valor) || 'É necessário conter o dígito da conta!']
  },
  convertDateTime (date) {
    var dataConvertida = ui.Format.Date(ui.Parse.Date(date), 'yyyy-MM-dd HH:mm:ss')
    return new Date(dataConvertida)
  },
  downloadExcel: function (th, e, dataSource, schema, name) {
    e.preventDefault();
    e.stopPropagation();
    const options = {};

    if (!dataSource || dataSource.length === 0) {
      th.$api.UI.ShowAlert('Não há dados para download');
      return false;
    }

    options.name = name || th.$route.meta.title;

    let fields = {};
    // eslint-disable-next-line no-unused-vars
    for (const [_, val] of Object.entries({
      ...JSON.parse(JSON.stringify(schema.filter((p) => !p.excelIgnore))),
    })) {
      const { value, text, format } = val;
      if (text === undefined) continue;
      fields = Object.assign({}, { ...fields, [text]: value });
      if (format === 'string') {
        options.stringifyLongNum = true;
      }
    }
    options.fields = fields;

    function fetch () {
      const excelData = JSON.parse(JSON.stringify(dataSource));
      // eslint-disable-next-line no-unused-vars
      for (const [_, val] of Object.entries({
        ...JSON.parse(JSON.stringify(schema.filter((p) => !p.excelIgnore))),
      })) {
        const { value, format, template } = val;
        if (format) {
          excelData.map((data, i) => {
            for (const [k, v] of Object.entries(data)) {
              if (value === k) {
                if (v || (v === false && template)) {
                  const formatValue = {
                    documento: th.$api.UI.Format.DocumentoFederal(v),
                    currency: th.$api.UI.Format.Currency(v),
                  }[format];
                  if (format === 'date' && v.length > 10) {
                    excelData[i][k] = th.$api.UI.Format.Date(v);
                  } else if (formatValue) {
                    excelData[i][k] = formatValue;
                  } else if (template) {
                    excelData[i][k] = template(excelData[i]);
                  } else {
                    excelData[i][k] = v;
                  }
                }
              }
            }
          });
        }
      }
      return excelData;
    }

    options.fetch = fetch;

    th.excelOptions = options;
    th.$nextTick(() => th.$refs.excel.generate());
  },
  RemoverCaracteresEspeciais (str) {
    return str.replace(/[^\w\s]/gi, '')
  },
  RetornoTipoPessoa (documento) {
    const tipoPessoa = documento && /^\d{11}$/.test(documento.replace(/\D/g, '')) ? 1 : 2
    return tipoPessoa
  },
  RetornoRenave (th, response, callback) {
    if (response.error) {
      const mensagem = JSON.parse(response.error)
      return th.$api.UI.Mensagem('erro', mensagem.Msg || response.error)
    } else {
      if (callback) {
        callback()
      }
    }
  },
  async GetParameters (th, codigoEmpresa) {
    const dtoParams = {
      parameters: [
        { name: 'codigoEmpresa', value: codigoEmpresa }
      ]
    }
    const parametros = {}
    const responseParam = await th.$api.Parametro.GetAll(dtoParams)

    responseParam.forEach(p => {
      try {
        parametros[p.identificador] = JSON.parse(p.valor)
      } catch {
        parametros[p.identificador] = p.valor
      }
    })
    return parametros
  },
})
